// src/components/AddUserModal.js

import { useState } from "react";
import { Button, Card, Form, Modal, Spinner, Toast } from "react-bootstrap";
import Swal from "sweetalert2";
import companyUserApi from "../../../api/companyUsers";
const AddUserModal = ({ show, onClose, selectedCompany, onInviteUser }) => {
  const [inviteEmail, setInviteEmail] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [selectedRole, setSelectedRole] = useState("Sender");
  const [loading, setLoading] = useState(false);
  const [userInivitationToast, setUserInivitatonToast] = useState(false);

  const handleSendInvite = async (e) => {
    e.preventDefault(); 

    if (!selectedCompany?.id) {
      console.error("Selected company is missing");
      return;
    }

    const inviteUserData = {
      companyId: selectedCompany.id,
      userEmail: inviteEmail,
      invitedByEmail: JSON.parse(localStorage.getItem("user"))?.userEmail,
      mobileNumber,
      role: selectedRole,
    };

    try {
      setLoading(true);
      await companyUserApi.inviteCompanyUser(inviteUserData);

      await Swal.fire({
        icon: "success",
        title: "Invitation Sent!",
        text: "User has been invited successfully.",
        confirmButtonText: "OK",
      });

      setInviteEmail("");
      setMobileNumber("");
      setSelectedRole("Sender");

      onInviteUser(true);
      onClose();
    } catch (error) {
      console.error("Error inviting user:", error);

      Swal.fire({
        icon: "error",
        title: "Invitation Failed",
        text: "Something went wrong. Please try again.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Add User to {selectedCompany?.companyName}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Card className="p-3">
          <h5>➕ Invite a User</h5>
          <Form>
            <Form.Group controlId="userEmail">
              <Form.Label>
                User Email <span style={{ color: "red" }}>*</span>
              </Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter user email"
                value={inviteEmail}
                onChange={(e) => setInviteEmail(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Group controlId="mobileNumber">
              <Form.Label>
                Mobile Number <span style={{ color: "red" }}>*</span>
              </Form.Label>
              <Form.Control
                type="tel"
                value={mobileNumber}
                onChange={(e) => setMobileNumber(e.target.value)}
                placeholder="Enter your mobile number"
                required
              />
            </Form.Group>

            <Form.Group controlId="userRole" className="mt-3">
              <Form.Label>
                User Role<span style={{ color: "red" }}>*</span>
              </Form.Label>
              <Form.Select
                value={selectedRole}
                onChange={(e) => setSelectedRole(e.target.value)}
                required
              >
                <option value="ADMIN">
                  Admin – Full access (can add users)
                </option>
                <option value="SENDER">
                  Sender – Can add reviewers, send documents
                </option>
                <option value="REVIEWER">
                  Reviewer – Can only review documents
                </option>
              </Form.Select>
            </Form.Group>

            <Button
              className="mt-3"
              variant="primary"
              type="submit"
              disabled={!inviteEmail || !mobileNumber || !selectedRole}
              onClick={handleSendInvite}
            >
              {loading ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />{" "}
                  Sending...
                </>
              ) : (
                "Send Invite"
              )}
            </Button>
          </Form>
        </Card>

        {/* Toast for user invitation */}
        <Toast
          onClose={() => setUserInivitatonToast(false)}
          show={userInivitationToast}
          delay={3000}
          autohide
          bg="success"
        >
          <Toast.Header>
            <strong className="me-auto">User Invited</strong>
          </Toast.Header>
          <Toast.Body className="text-white">
            User invitation sent successfully.
          </Toast.Body>
        </Toast>
      </Modal.Body>
    </Modal>
  );
};

export default AddUserModal;
